import axios from "axios";

const API = axios;
const BASE_URL = 'https://api.testigoventures.com';//reder url
// const BASE_URL='http://localhost:4000'; ///localhost
// const BASE_URL='http://103.15.67.180:4000';

export {
    API,
    BASE_URL
}